import { request } from 'http'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import SessionHistoryEditTimeModal from 'src/components/drivers/SessionHistoryEditTimeModal'
import { IDriverEditSessionObject, IDriverSessionFilters } from 'src/types'
import { IStoreState } from 'src/types/state'
import * as actions from '../../state/actions/drivers'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    history: ownProps.history,
    match: ownProps.match,
    operatorId: ownProps.operatorId,
    filters: ownProps.filters
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getDriversSessionList: (filters: IDriverSessionFilters) => dispatch(actions.getDriverSessionListV2(filters)),
    saveData: async (request: IDriverEditSessionObject): Promise<any> => {
      return await dispatch(actions.editDriverSession(request))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionHistoryEditTimeModal)



// WEBPACK FOOTER //
// ./src/containers/drivers/SessionHistoryEditTimeModal.ts